import axiosInstance from "../../apiAxios/axiosInstance";
export const getUserList = async (payload) => {
  const response = await axiosInstance.post("/admin/user-list",payload);
  return response.data;
};

export const ActiveUserList = async (payload) => {
  const response = await axiosInstance.post("/admin/user-active-list",payload);
  return response.data;
};

export const getUserListByCategory = async (payload) => {
  const response = await axiosInstance.post("/admin/user-by-category",payload);
  return response.data;
};

export const addUser = async (payload) => {
  const response = await axiosInstance.post("/admin/user-registration",payload);
  return response.data;
};


export const getUserDetails = async (payload) => {
  const response = await axiosInstance.post("/admin/user-show", payload);
  return response.data;
};
export const updateUser = async (data) => {
  const response = await axiosInstance.post("/admin/user-update",data);

  return response.data;
};

export const deleteUser = async (payload) => {
  const response = await axiosInstance.post("/admin/user-delete",payload);
  return response.data;
}; 
export const updateUserStatus = (payload) =>{
 const response=   axiosInstance.post("/admin/user-status-update", payload)
   return response
}
export const getDeletedVendorList = async (payload) => {
  const response = await axiosInstance.post("/admin/restore-user-list", payload);
  return response.data;
};

export const restorevendor = async (payload) => {
  const response = await axiosInstance.post("/admin/user-restore", payload);
  return response.data;
};

export const permanentDeleteVendor = async (ids) => {
  const response = await axiosInstance.post("/admin/user-permanent-delete", {ids});
  return response.data;
};



